import superagentPromise from "superagent-promise";
import _superagent from "superagent";
import authStore from "stores/auth";

const superagent = superagentPromise(_superagent, global.Promise);

const API_ROOT = "https://sagresrotas.com.br/sagresrotasserver/sagresrotasserver.dll";

const handleErrors = (err) => {
  if (err && err.response && err.response.status === 401) {
    // authStore.logout();
  }
  return err;
};

const responseBody = (res) => res.body;

function limparCaracteresControle(text) {
  // Remove todos os caracteres ASCII de controle (0-31), exceto \n \r \t
  return text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '');
}

const requests = {
  del: (url) => superagent.del(`${API_ROOT}${url}`).end(handleErrors).then(responseBody),
  get: (url) => superagent.get(`${API_ROOT}${url}`).end(handleErrors).then(responseBody),
  put: (url, body) =>
    superagent.put(`${API_ROOT}${url}`, body).end(handleErrors).then(responseBody),
  post: (url, body) => {
    if (url === "/usuario/login") {
      return superagent
        .post(`${API_ROOT}${url}`, body)
        .parse(({ text }) => JSON.parse(limparCaracteresControle(text.replaceAll("", ""))))
        .end(handleErrors)
        .then(responseBody);
    }
    return superagent
      .post(`${API_ROOT}${url}`, body)
      .send({ SessaoGuidId: `${authStore.sessaoGuidId}` })
      .send({ RefreshTokenSessao: `${authStore.refreshTokenSessao}` })
      .parse(({ text }) => JSON.parse(limparCaracteresControle(text.replaceAll("", ""))))
      .end(handleErrors)
      .then((res) => {
        const { body } = res;
  
        if (body?.SessaoGuidId && body.SessaoGuidId !== authStore.sessaoGuidId) {
          authStore.setSessaoGuidId(body.SessaoGuidId);
        }
   
        if (
          body?.RefreshTokenSessao &&
          body.RefreshTokenSessao !== authStore.refreshTokenSessao
        ) {
          authStore.setRefreshTokenSessao(body.RefreshTokenSessao);
        }
  
        return res;
      })
      .then(responseBody);
  },
};

const Auth = {
  criarSessao: () => requests.post("/sessao/criar", {}),
  checarSessao: () => requests.post("/sessao/checar", {}),
  login: (login, senha) =>
    requests.post("/usuario/login", {
      Login: login,
      Senha: senha,
    }),
  logout: () => requests.post("/usuario/logout", {}),
};

const Pedidos = {
  listarPedidos: () => requests.post("/pedidos/listar", {
    Status: [0,1,2,3,4,5,6,7,8,9],
  }),
  listarPedidosHistorico: () => requests.post("/pedidos/listar", {
    Status: [0,1,2,3,4,5,6,7,8,9],
    FiltrarUltimasHoras: 0
  }),
  definirEntregadores: (pedidos) =>
    requests.post("/pedidos/definirentregador", {
      Pedidos: pedidos
    }),
  definirStatus: (pedidos) =>
    requests.post("/pedidos/definirstatus", {
      Pedidos: pedidos
    })
}

const Entregadores = {
  listarEntregadores: () => requests.post("/entregadores/listar", {}),
  cadastrarEntregador: (nome, nomeResumido, celular, codigoExterno, cor ) =>
    requests.post("/tabela/manutenir", {
    NomeTabela: "Entregadores",
    Entregadores:
    [
        {
            "OperacaoBD":"A",
            "Nome":nome,
            "NomeResumido":nomeResumido,
            "Celular":celular,
            "CodigoExternoEntregador":codigoExterno,
            "Ativo":1,
            "Cor":cor || ""
        }
    ]
    }),
    editarEntregador: (id, nome, nomeResumido, celular, codigoExterno, cor ) =>
      requests.post("/tabela/manutenir", {
      NomeTabela: "Entregadores",
      Entregadores:
      [
          {
              "OperacaoBD":"E",
              "EntregadorId":id,
              "Nome":nome,
              "NomeResumido":nomeResumido,
              "Celular":celular,
              "CodigoExternoEntregador":codigoExterno,
              "Ativo":1,
              "Cor":cor || ""
          }
      ]
      }),
    cadastrarUsuarioEntregador: (entregadorId, nome, login, senha, ativo = 1) =>
      requests.post("/entregador/usuario", {
        EntregadorId: entregadorId,
        Nome: nome,
        Login: login,
        Senha: senha,
        Ativo: ativo
      }),
    mudarStatusEntregador: (id, status ) =>
      requests.post("/tabela/manutenir", {
      NomeTabela: "Entregadores",
      Entregadores:
      [
          {
              "OperacaoBD":"E",
              "EntregadorId":id,
              "Ativo":status ? 1 : 0
          }
      ]
      }),
      excluirEntregador: (id) =>
        requests.post("/tabela/manutenir", {
        NomeTabela: "Entregadores",
        Entregadores:
        [
            {
                "OperacaoBD":"D",
                "EntregadorId":id,
            }
        ]
        }),

}

const Relatorios = {
  buscarDashboard: (dataInicial, dataFinal) =>
    requests.post("/relatorio/dashboard", {
      DataInicial: dataInicial,
      DataFinal: dataFinal
    })
}

export default {
  Auth,
  Pedidos,
  Entregadores,
  Relatorios
};
